<template>
  <div ref="container">
    <div class="collectionGoods" v-if="collectProductList.length > 0">
      <div
        
        class="item acea-row row-between-wrapper" style="height: auto;"
        v-for="(item, index) in collectProductList"
        :key="index"
      >
        <div class="pictrue"><img :src="item.logo" /></div>
        <div class="text acea-row row-column-between">
          <div class="infor line1">{{ item.real_name }}</div>
		  <div class="infor line1">￥{{ item.number }}</div>
          <div class="acea-row row-between-wrapper">
            <div class="money">{{ item.mark }}</div>
             
          </div>
		  
        </div>
		<div style="line-height: :24px;padding: 5px 0;" v-html="item.goods">
		  
		  
		</div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div
      class="noCommodity"
      style="background-color:#fff;"
      v-if="collectProductList.length < 1 && page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/no.png" class="image" />
      </div>
       
    </div>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getLsxfinfo, getCollectDel } from "@api/user";
import Loading from "@components/Loading";
export default {
  name: "GoodsXfdetail",
  components: {
    Recommend,
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 20,
      collectProductList: [],
      loadTitle: "",
      loading: false,
      loadend: false
    };
  },
  watch: {
    $route(to) {
      if (to.name === "NewsDetail") this.articleDetails();
    }
  },
  mounted: function() {
    this.get_user_collect_product();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.get_user_collect_product();
    });
  },
  methods: {
    get_user_collect_product: function() {
      let that = this;
	 console.log(this.$route.params.id);
	 console.log('1111');
	 let id = this.$route.params.id;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getLsxfinfo(id,that.page, that.limit).then(res => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
		
        that.collectProductList.push.apply(that.collectProductList, res.data);
		
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    }
    
  }
};
</script>
